<template>
  <div class="main">
    <h2>配置考生</h2>
    <Candidate
      ref="candidate"
      :editData="editType == true ? list_vip : 'null'"
    />
    <div class="button_view">
      <div>
        <el-button type="primary" @click="stepPrevious">上一步</el-button>
        <el-button type="primary" @click="submitConfigure">完成</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Candidate from "@/components/addCandidate/Candidate.vue";
import training from "@/api/trainingApi";
export default {
  data() {
    return {
      editType: false, // 编辑状态
      list_vip: [], // 新定义的数组
    };
  },
  props: ["cutcoms"],
  created() {
    sessionStorage.setItem("trainingState", "true");
  },
  components: {
    Candidate,
  },
  activated() {
    console.log(this.$parent.operateState);
    this.$nextTick(() => {
      if (this.$parent.operateState == 0) {
        this.editType = false;
        this.list_vip = [];
      } else if (this.$parent.operateState == 1) {
        this.editType = true;
        this.list_vip = this.$parent.list_vip;
      }
    });
    console.log(this.$parent.list_vip,this.list_vip);
    
  },
  methods: {
    stepPrevious() {
      this.cutcoms(1);
      this.$parent.list_vip = this.list_vip;
      // this.$refs.candidate.list_vip = this.$parent.list_vip;
    },
    async submitConfigure() {
      if (this.$refs.candidate.getData.length) {
        const obj = {
          name: this.$parent.addInfo.name,
          begainTime: this.$parent.addInfo.startTime, // 开始时间
          days: this.$parent.addInfo.duration, // 任务 天数 根据选择的月，年 计算
          remark: this.$parent.addInfo.notes, // 任务备注
          studentIdArr: "",
        };
        let newarr = this.$refs.candidate.getData.map((item) => {
          return item.UserID;
        });
        obj.studentIdArr = JSON.stringify(newarr);
        if (this.$parent.operateState == 1) {
          // 编辑的状态
          obj.trainId = this.$parent.examRow.tranid;
          const { data } = await training.editTraining(obj);
          if (data.Status == 200) {
            this.$message({
              message: `“${obj.name}”培训编辑成功`,
              type: "success",
            });
            this.list_vip = [];
            this.$parent.list_vip = [];
            this.$parent.operateState = "";
            this.cutcoms(0);
          } else {
            this.$message({
              message: data.Data,
              type: "warning",
            });
          }
        } else {
          // 添加
          const { data } = await training.addTraining(obj);
          if (data.Status == 200) {
            this.$message({
              message: `“${obj.name}”培训添加成功`,
              type: "success",
            });
            this.list_vip = [];
            this.$parent.list_vip = [];
            this.$parent.operateState = "";
            this.cutcoms(0);
          } else {
            this.$message({
              message: data.Data,
              type: "warning",
            });
          }
        }

        // console.log(data);
      } else {
        this.$message({
          message: "警告，请选择考生",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  min-height: 780px;
  padding: 24px;
  .button_view {
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
      display: flex;
      padding: 16px;
      > .el-button {
        width: 120px;
        margin-right: 16px;
      }
    }
  }
}
</style>